import React, { Suspense, lazy } from "react";

import { Route, Routes } from "react-router-dom";
//import { useSelector } from "react-redux";

const Home = lazy(() => import("../views/view.home"));
const ViewContact = lazy(() => import("../views/view.contact"));
const ViewResources = lazy(() => import("../views/view.resources"));

const PageLoader = () => (
    <div className="flex h-screen w-full items-center justify-center bg-duna-bg">
        <div className="w-8 h-8 border-4 border-duna-accent border-t-transparent rounded-full animate-spin"></div>
    </div>
);

export default function BasicRouting() {

    //const user = useSelector((state)=> state.userReducer.user);

    return (
        <Suspense fallback={<PageLoader />}>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact" element={<ViewContact />} />
                <Route path="/playground" element={<ViewResources />} />
                <Route path="*" element={<Home />} /> 
            </Routes>
        </Suspense>
    )
}
